import React, {useState, useRef, useEffect} from 'react';
import {AccordionArrow} from '../../styles/icons';

import _ from 'lodash';

const Accordion = (props) => {
    const {isAccordionArrow, children, title} = props;

    const [active, setActive] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        contentRef.current.style.maxHeight = active ? `${contentRef.current.scrollHeight}px` : '0px';
    }, [contentRef, active]);

    const toggleActive = (event) => {
        event.stopPropagation();
        setActive(!active);
    };

    if (isAccordionArrow) {
        return (
            <div
                style={props.style}
                className={`basic-accordion-section ${props.planAccordionWrapperClass}`}
                onClick={(evt) => {
                    !_.isEmpty(children) && toggleActive(evt);
                }}
            >
                <button type='button' className='basic-accordion-title pl-0'>
                    <div className='maxis-semiBold fs-14 fs-lg-16 accordion-title-content'>{title}</div>
                    {!_.isEmpty(children) ? (
                        <span className={active ? 'basic-accordion-icon rotate-icon' : 'basic-accordion-icon'}>
                            <AccordionArrow />
                        </span>
                    ) : (
                        ''
                    )}
                </button>
                <div
                    ref={contentRef}
                    className={`d-flex flex-column maxis-light fs-14 basic-accordion-content lh-normal ${
                        active ? 'mb-2' : ''
                    }`}
                >
                    {children}
                </div>
            </div>
        );
    }

    return (
        <div className='accordion-section'>
            <button type='button' className='accordion-title pl-0' onClick={toggleActive}>
                <p className='my-8px maxis-semiBold'>{title}</p>
                <span className={active ? 'accordion-icon rotate' : 'accordion-icon'}>+</span>
            </button>
            <div ref={contentRef} className={`d-flex flex-column accordion-content ${active ? 'mb-10px' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default Accordion;
